(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-looks-combo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Same JS as customer-looks-row.liquid (drag-to-scroll, chip toggle,
    // multi-add-to-cart, multi-item popup override). Self-contained per
    // section instance via [data-cl-row] wrapper match.
    const sections = document.querySelectorAll('.cl-combo-section[data-cl-row]');
    sections.forEach((section) => {
      // Drag-to-scroll (desktop only)
      const scroller = section.querySelector('.cl-row-scroll');
      if (scroller && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let pointerDown = false, startX = 0, startY = 0, scrollStart = 0, dragged = false;
        const DRAG_THRESHOLD = 5;

        scroller.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          pointerDown = true; dragged = false;
          startX = e.pageX; startY = e.pageY;
          scrollStart = scroller.scrollLeft;
        });
        scroller.addEventListener('mousemove', (e) => {
          if (!pointerDown) return;
          const dx = e.pageX - startX, dy = e.pageY - startY;
          if (!dragged && Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            dragged = true;
            scroller.classList.add('is-dragging');
          }
          if (dragged) { scroller.scrollLeft = scrollStart - dx; e.preventDefault(); }
        });
        const release = () => {
          if (!pointerDown) return;
          pointerDown = false;
          if (dragged) scroller.classList.remove('is-dragging');
        };
        scroller.addEventListener('mouseup', release);
        scroller.addEventListener('mouseleave', release);
        scroller.addEventListener('click', (e) => {
          if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
        }, true);
        scroller.addEventListener('dragstart', (e) => e.preventDefault());
      }

      // Per-card chip + add-to-cart logic
      const cards = section.querySelectorAll('[data-cl-card]');
      cards.forEach((card) => {
        const inputs = card.querySelectorAll('.cl-chip__input');
        const button = card.querySelector('[data-cl-add]');
        const label = card.querySelector('[data-cl-add-label]');
        if (!button || !label) return;

        const baseLabel = button.dataset.labelBase || 'Add to cart';
        const updateLabel = () => {
          const checked = card.querySelectorAll('.cl-chip__input:checked');
          const n = checked.length;
          button.disabled = n === 0;
          label.textContent = n === 0 ? baseLabel : baseLabel + ' (' + n + ')';
        };
        inputs.forEach((input) => input.addEventListener('change', updateLabel));

        card.querySelectorAll('.cl-chip__thumb').forEach((a) => {
          a.addEventListener('click', (e) => {
            e.stopPropagation(); e.preventDefault();
            window.location.href = a.getAttribute('href');
          });
        });

        button.addEventListener('click', async (e) => {
          e.preventDefault();
          const checked = Array.from(card.querySelectorAll('.cl-chip__input:checked'));
          if (!checked.length) return;
          const items = checked.map((i) => ({ id: parseInt(i.dataset.variantId, 10), quantity: 1 }));

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sectionsList = (cart && typeof cart.getSectionsToRender === 'function')
            ? cart.getSectionsToRender().map((s) => s.id) : [];
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);

          button.classList.add('is-loading');
          button.disabled = true;
          try {
            const r = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items, sections: sectionsList, sections_url: window.location.pathname }),
            });
            const response = await r.json();
            if (!r.ok || response.status) {
              throw new Error(response.description || ('add failed (' + r.status + ')'));
            }

            if (cart && typeof cart.renderContents === 'function') {
              const respItems = response.items || [response];
              const lastItem = respItems[respItems.length - 1] || {};
              cart.renderContents({
                key: lastItem.key,
                product_id: lastItem.product_id,
                sections: response.sections,
              });

              // Multi-item popup: replace product slot with our compact list
              if (respItems.length > 1) {
                const container = document.getElementById('cart-notification-product');
                if (container) {
                  const list = document.createElement('div');
                  list.className = 'cl-multi-add';
                  checked.forEach((input) => {
                    const chipEl = input.closest('.cl-chip');
                    if (!chipEl) return;
                    const thumb = chipEl.querySelector('.cl-chip__thumb img');
                    const titleEl = chipEl.querySelector('.cl-chip__title');
                    const priceEl = chipEl.querySelector('.cl-chip__price');

                    const item = document.createElement('div');
                    item.className = 'cl-multi-item';
                    if (thumb) {
                      const img = document.createElement('img');
                      img.src = thumb.currentSrc || thumb.src;
                      img.alt = thumb.alt || '';
                      img.width = 48; img.height = 48;
                      item.appendChild(img);
                    }
                    const body = document.createElement('div');
                    body.className = 'cl-multi-item__body';
                    const title = document.createElement('span');
                    title.className = 'cl-multi-item__title';
                    title.textContent = titleEl ? titleEl.textContent.trim() : '';
                    body.appendChild(title);
                    const price = document.createElement('span');
                    price.className = 'cl-multi-item__price';
                    if (priceEl) price.innerHTML = priceEl.innerHTML;
                    body.appendChild(price);
                    item.appendChild(body);
                    list.appendChild(item);
                  });
                  container.innerHTML = '';
                  container.appendChild(list);
                }

                if (!document.getElementById('cl-multi-add-styles')) {
                  const style = document.createElement('style');
                  style.id = 'cl-multi-add-styles';
                  style.textContent =
                    '.cl-multi-add{display:flex;flex-direction:column;gap:8px;padding:4px 0}' +
                    '.cl-multi-item{display:grid;grid-template-columns:48px 1fr;gap:12px;align-items:center;padding:8px 10px;background:rgba(0,0,0,.04);border-radius:4px}' +
                    '.cl-multi-item img{width:48px;height:48px;object-fit:cover;border-radius:2px;display:block}' +
                    '.cl-multi-item__body{display:flex;flex-direction:column;gap:2px;min-width:0}' +
                    '.cl-multi-item__title{font-size:13px;font-weight:600;line-height:1.3;color:#2D2D2D;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
                    '.cl-multi-item__price{font-size:12px;line-height:1.2;color:#2D2D2D}' +
                    '.cl-multi-item__price .cl-chip__price-now{color:#2D2D2D;font-weight:600}' +
                    '.cl-multi-item__price .cl-chip__price-was{text-decoration:line-through;color:#6B6868;margin-left:4px;font-weight:400}';
                  document.head.appendChild(style);
                }
              }
            }

            button.classList.remove('is-loading');
            button.classList.add('is-success');
            label.textContent = '✓';
            setTimeout(() => {
              button.classList.remove('is-success');
              checked.forEach((i) => { i.checked = false; });
              updateLabel();
            }, 1800);
          } catch (err) {
            button.classList.remove('is-loading');
            button.disabled = false;
            const msg = (err && err.message) ? String(err.message) : '';
            let displayMsg = 'Prøv igen';
            if (/udsolgt|sold[- ]?out|unavailable/i.test(msg)) {
              displayMsg = 'Udsolgt — fjern og prøv igen';
            } else if (/422|400/.test(msg)) {
              displayMsg = 'Kunne ikke tilføjes';
            }
            label.textContent = displayMsg;
            setTimeout(() => { if (label.textContent === displayMsg) updateLabel(); }, 4000);
            console.error('[customer-looks-combo] add to cart failed', err);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-looks-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-cl-row]');
    sections.forEach((section) => {
      // ─── Click-and-drag horizontal scroll (desktop only) ───────────────
      // Threshold of 5px distinguishes drag from click — chips and the
      // add-to-cart button still respond to genuine clicks.
      const scroller = section.querySelector('.cl-row-scroll');
      if (scroller && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let pointerDown = false;
        let startX = 0;
        let startY = 0;
        let scrollStart = 0;
        let dragged = false;
        const DRAG_THRESHOLD = 5;

        scroller.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return; // left click only
          pointerDown = true;
          dragged = false;
          startX = e.pageX;
          startY = e.pageY;
          scrollStart = scroller.scrollLeft;
        });

        scroller.addEventListener('mousemove', (e) => {
          if (!pointerDown) return;
          const dx = e.pageX - startX;
          const dy = e.pageY - startY;
          if (!dragged && Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            dragged = true;
            scroller.classList.add('is-dragging');
          }
          if (dragged) {
            scroller.scrollLeft = scrollStart - dx;
            e.preventDefault();
          }
        });

        const release = () => {
          if (!pointerDown) return;
          pointerDown = false;
          if (dragged) scroller.classList.remove('is-dragging');
        };
        scroller.addEventListener('mouseup', release);
        scroller.addEventListener('mouseleave', release);

        // Swallow the synthetic click that follows a drag so chips don't
        // toggle and links don't navigate when the user was just scrolling.
        scroller.addEventListener('click', (e) => {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
          }
        }, true);

        // Stop browser's native image-drag ghost
        scroller.addEventListener('dragstart', (e) => e.preventDefault());
      }

      const cards = section.querySelectorAll('[data-cl-card]');
      cards.forEach((card) => {
        const inputs = card.querySelectorAll('.cl-chip__input');
        const button = card.querySelector('[data-cl-add]');
        const label = card.querySelector('[data-cl-add-label]');
        if (!button || !label) return;

        const baseLabel = button.dataset.labelBase || 'Add to cart';
        const updateLabel = () => {
          const checked = card.querySelectorAll('.cl-chip__input:checked');
          const n = checked.length;
          button.disabled = n === 0;
          label.textContent = n === 0 ? baseLabel : baseLabel + ' (' + n + ')';
        };

        inputs.forEach((input) => input.addEventListener('change', updateLabel));

        card.querySelectorAll('.cl-chip__thumb').forEach((a) => {
          a.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            window.location.href = a.getAttribute('href');
          });
        });

        button.addEventListener('click', async (e) => {
          e.preventDefault();
          const checked = Array.from(card.querySelectorAll('.cl-chip__input:checked'));
          if (!checked.length) return;
          const items = checked.map((i) => ({ id: parseInt(i.dataset.variantId, 10), quantity: 1 }));

          // Hand off to theme's cart UI: cart-notification (popup) on most
          // pages, falls back to cart-drawer (slide-in) when present. Both
          // expose getSectionsToRender() + renderContents(response) so the
          // cart-icon-bubble counter and notification popup update without
          // a full page reload — same flow product-form.js uses.
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = (cart && typeof cart.getSectionsToRender === 'function')
            ? cart.getSectionsToRender().map((s) => s.id)
            : [];
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);

          button.classList.add('is-loading');
          button.disabled = true;
          try {
            const r = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items,
                sections,
                sections_url: window.location.pathname,
              }),
            });
            const response = await r.json();
            if (!r.ok || response.status) {
              throw new Error(response.description || ('add failed (' + r.status + ')'));
            }

            // Multi-item response is { items: [...], sections: {...} }; renderContents
            // expects single-item shape with .key + .product_id. Use last item so
            // the popup shows the most recently added variant.
            if (cart && typeof cart.renderContents === 'function') {
              const respItems = response.items || [response];
              const lastItem = respItems[respItems.length - 1] || {};
              cart.renderContents({
                key: lastItem.key,
                product_id: lastItem.product_id,
                sections: response.sections,
              });

              // For multi-item adds, replace the popup's product slot with
              // our own compact list built from chip data — avoids the
              // theme's bulky .cart-item layout for full styling control.
              if (respItems.length > 1) {
                const container = document.getElementById('cart-notification-product');
                if (container) {
                  const list = document.createElement('div');
                  list.className = 'cl-multi-add';
                  checked.forEach((input) => {
                    const chipEl = input.closest('.cl-chip');
                    if (!chipEl) return;
                    const thumb = chipEl.querySelector('.cl-chip__thumb img');
                    const titleEl = chipEl.querySelector('.cl-chip__title');
                    const priceEl = chipEl.querySelector('.cl-chip__price');

                    const item = document.createElement('div');
                    item.className = 'cl-multi-item';
                    if (thumb) {
                      const img = document.createElement('img');
                      img.src = thumb.currentSrc || thumb.src;
                      img.alt = thumb.alt || '';
                      img.width = 48; img.height = 48;
                      item.appendChild(img);
                    }
                    const body = document.createElement('div');
                    body.className = 'cl-multi-item__body';
                    const title = document.createElement('span');
                    title.className = 'cl-multi-item__title';
                    title.textContent = titleEl ? titleEl.textContent.trim() : '';
                    body.appendChild(title);
                    const price = document.createElement('span');
                    price.className = 'cl-multi-item__price';
                    if (priceEl) price.innerHTML = priceEl.innerHTML;
                    body.appendChild(price);
                    item.appendChild(body);
                    list.appendChild(item);
                  });
                  container.innerHTML = '';
                  container.appendChild(list);
                }

                if (!document.getElementById('cl-multi-add-styles')) {
                  const style = document.createElement('style');
                  style.id = 'cl-multi-add-styles';
                  style.textContent =
                    '.cl-multi-add{display:flex;flex-direction:column;gap:8px;padding:4px 0}' +
                    '.cl-multi-item{display:grid;grid-template-columns:48px 1fr;gap:12px;align-items:center;padding:8px 10px;background:rgba(0,0,0,.04);border-radius:4px}' +
                    '.cl-multi-item img{width:48px;height:48px;object-fit:cover;border-radius:2px;display:block}' +
                    '.cl-multi-item__body{display:flex;flex-direction:column;gap:2px;min-width:0}' +
                    '.cl-multi-item__title{font-size:13px;font-weight:600;line-height:1.3;color:#2D2D2D;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
                    '.cl-multi-item__price{font-size:12px;line-height:1.2;color:#2D2D2D}' +
                    '.cl-multi-item__price .cl-chip__price-now{color:#2D2D2D;font-weight:600}' +
                    '.cl-multi-item__price .cl-chip__price-was{text-decoration:line-through;color:#6B6868;margin-left:4px;font-weight:400}';
                  document.head.appendChild(style);
                }
              }
            }

            button.classList.remove('is-loading');
            button.classList.add('is-success');
            label.textContent = '✓';
            setTimeout(() => {
              button.classList.remove('is-success');
              checked.forEach((i) => { i.checked = false; });
              updateLabel();
            }, 1800);
          } catch (err) {
            button.classList.remove('is-loading');
            button.disabled = false;
            const msg = (err && err.message) ? String(err.message) : '';
            let displayMsg = 'Prøv igen';
            if (/udsolgt|sold[- ]?out|unavailable/i.test(msg)) {
              displayMsg = 'Udsolgt — fjern og prøv igen';
            } else if (/422|400/.test(msg)) {
              displayMsg = 'Kunne ikke tilføjes';
            }
            label.textContent = displayMsg;
            setTimeout(() => { if (label.textContent === displayMsg) updateLabel(); }, 4000);
            console.error('[customer-looks-row] add to cart failed', err);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-videos-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-cv-row]');
    sections.forEach((section) => {
      // Drag-to-scroll (desktop only)
      const scroller = section.querySelector('.cv-row-scroll');
      if (scroller && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let pointerDown = false, startX = 0, startY = 0, scrollStart = 0, dragged = false;
        const DRAG_THRESHOLD = 5;
        scroller.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          pointerDown = true; dragged = false;
          startX = e.pageX; startY = e.pageY;
          scrollStart = scroller.scrollLeft;
        });
        scroller.addEventListener('mousemove', (e) => {
          if (!pointerDown) return;
          const dx = e.pageX - startX, dy = e.pageY - startY;
          if (!dragged && Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            dragged = true;
            scroller.classList.add('is-dragging');
          }
          if (dragged) { scroller.scrollLeft = scrollStart - dx; e.preventDefault(); }
        });
        const release = () => {
          if (!pointerDown) return;
          pointerDown = false;
          if (dragged) scroller.classList.remove('is-dragging');
        };
        scroller.addEventListener('mouseup', release);
        scroller.addEventListener('mouseleave', release);
        scroller.addEventListener('click', (e) => {
          if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
        }, true);
        scroller.addEventListener('dragstart', (e) => e.preventDefault());
      }

      // Per-video play/pause + audio toggle (only one video plays at a time)
      let currentlyPlaying = null;
      const wraps = section.querySelectorAll('[data-cv-video-wrap]');
      wraps.forEach((wrap) => {
        const video = wrap.querySelector('[data-cv-video]');
        const playBtn = wrap.querySelector('[data-cv-play]');
        const audioBtn = wrap.querySelector('[data-cv-audio]');
        if (!video) return;

        const togglePlay = (e) => {
          if (e) e.preventDefault();
          if (video.paused) {
            if (currentlyPlaying && currentlyPlaying !== video) currentlyPlaying.pause();
            video.play().then(() => {
              wrap.classList.add('is-playing');
              currentlyPlaying = video;
            }).catch(() => {});
          } else {
            video.pause();
            wrap.classList.remove('is-playing');
            if (currentlyPlaying === video) currentlyPlaying = null;
          }
        };
        if (playBtn) playBtn.addEventListener('click', togglePlay);
        video.addEventListener('click', togglePlay);
        video.addEventListener('ended', () => {
          wrap.classList.remove('is-playing');
          if (currentlyPlaying === video) currentlyPlaying = null;
        });
        video.addEventListener('pause', () => {
          wrap.classList.remove('is-playing');
          if (currentlyPlaying === video) currentlyPlaying = null;
        });
        if (audioBtn) {
          audioBtn.addEventListener('click', (e) => {
            e.preventDefault(); e.stopPropagation();
            video.muted = !video.muted;
            audioBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
            audioBtn.setAttribute('aria-label', video.muted ? 'Slå lyd til' : 'Slå lyd fra');
            if (!video.muted && video.paused) togglePlay();
          });
        }
      });

      // Per-card chip + multi-add-to-cart (same logic as customer-looks-row)
      const cards = section.querySelectorAll('[data-cv-card]');
      cards.forEach((card) => {
        const inputs = card.querySelectorAll('.cl-chip__input');
        const button = card.querySelector('[data-cv-add]');
        const label = card.querySelector('[data-cv-add-label]');
        if (!button || !label) return;

        const baseLabel = button.dataset.labelBase || 'Add to cart';
        const updateLabel = () => {
          const checked = card.querySelectorAll('.cl-chip__input:checked');
          const n = checked.length;
          button.disabled = n === 0;
          label.textContent = n === 0 ? baseLabel : baseLabel + ' (' + n + ')';
        };
        inputs.forEach((input) => input.addEventListener('change', updateLabel));

        card.querySelectorAll('.cl-chip__thumb').forEach((a) => {
          a.addEventListener('click', (e) => {
            e.stopPropagation(); e.preventDefault();
            window.location.href = a.getAttribute('href');
          });
        });

        button.addEventListener('click', async (e) => {
          e.preventDefault();
          const checked = Array.from(card.querySelectorAll('.cl-chip__input:checked'));
          if (!checked.length) return;
          const items = checked.map((i) => ({ id: parseInt(i.dataset.variantId, 10), quantity: 1 }));

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sectionsList = (cart && typeof cart.getSectionsToRender === 'function')
            ? cart.getSectionsToRender().map((s) => s.id) : [];
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);

          button.classList.add('is-loading');
          button.disabled = true;
          try {
            const r = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items, sections: sectionsList, sections_url: window.location.pathname }),
            });
            const response = await r.json();
            if (!r.ok || response.status) {
              throw new Error(response.description || ('add failed (' + r.status + ')'));
            }

            if (cart && typeof cart.renderContents === 'function') {
              const respItems = response.items || [response];
              const lastItem = respItems[respItems.length - 1] || {};
              cart.renderContents({
                key: lastItem.key,
                product_id: lastItem.product_id,
                sections: response.sections,
              });

              if (respItems.length > 1) {
                const container = document.getElementById('cart-notification-product');
                if (container) {
                  const list = document.createElement('div');
                  list.className = 'cl-multi-add';
                  checked.forEach((input) => {
                    const chipEl = input.closest('.cl-chip');
                    if (!chipEl) return;
                    const thumb = chipEl.querySelector('.cl-chip__thumb img');
                    const titleEl = chipEl.querySelector('.cl-chip__title');
                    const priceEl = chipEl.querySelector('.cl-chip__price');
                    const item = document.createElement('div');
                    item.className = 'cl-multi-item';
                    if (thumb) {
                      const img = document.createElement('img');
                      img.src = thumb.currentSrc || thumb.src;
                      img.alt = thumb.alt || '';
                      img.width = 48; img.height = 48;
                      item.appendChild(img);
                    }
                    const body = document.createElement('div');
                    body.className = 'cl-multi-item__body';
                    const title = document.createElement('span');
                    title.className = 'cl-multi-item__title';
                    title.textContent = titleEl ? titleEl.textContent.trim() : '';
                    body.appendChild(title);
                    const price = document.createElement('span');
                    price.className = 'cl-multi-item__price';
                    if (priceEl) price.innerHTML = priceEl.innerHTML;
                    body.appendChild(price);
                    item.appendChild(body);
                    list.appendChild(item);
                  });
                  container.innerHTML = '';
                  container.appendChild(list);
                }
                if (!document.getElementById('cl-multi-add-styles')) {
                  const style = document.createElement('style');
                  style.id = 'cl-multi-add-styles';
                  style.textContent =
                    '.cl-multi-add{display:flex;flex-direction:column;gap:8px;padding:4px 0}' +
                    '.cl-multi-item{display:grid;grid-template-columns:48px 1fr;gap:12px;align-items:center;padding:8px 10px;background:rgba(0,0,0,.04);border-radius:4px}' +
                    '.cl-multi-item img{width:48px;height:48px;object-fit:cover;border-radius:2px;display:block}' +
                    '.cl-multi-item__body{display:flex;flex-direction:column;gap:2px;min-width:0}' +
                    '.cl-multi-item__title{font-size:13px;font-weight:600;line-height:1.3;color:#2D2D2D;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
                    '.cl-multi-item__price{font-size:12px;line-height:1.2;color:#2D2D2D}' +
                    '.cl-multi-item__price .cl-chip__price-now{color:#2D2D2D;font-weight:600}' +
                    '.cl-multi-item__price .cl-chip__price-was{text-decoration:line-through;color:#6B6868;margin-left:4px;font-weight:400}';
                  document.head.appendChild(style);
                }
              }
            }

            button.classList.remove('is-loading');
            button.classList.add('is-success');
            label.textContent = '✓';
            setTimeout(() => {
              button.classList.remove('is-success');
              checked.forEach((i) => { i.checked = false; });
              updateLabel();
            }, 1800);
          } catch (err) {
            button.classList.remove('is-loading');
            button.disabled = false;
            const msg = (err && err.message) ? String(err.message) : '';
            let displayMsg = 'Prøv igen';
            if (/udsolgt|sold[- ]?out|unavailable/i.test(msg)) {
              displayMsg = 'Udsolgt — fjern og prøv igen';
            } else if (/422|400/.test(msg)) {
              displayMsg = 'Kunne ikke tilføjes';
            }
            label.textContent = displayMsg;
            setTimeout(() => { if (label.textContent === displayMsg) updateLabel(); }, 4000);
            console.error('[customer-videos-row] add to cart failed', err);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-lp-root]');
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var preview = params.get('lp_preview') === '1';
    var enabled = root.getAttribute('data-lp-enabled') === '1';
    var start = parseInt(root.getAttribute('data-lp-start'), 10);
    var end = parseInt(root.getAttribute('data-lp-end'), 10);
    var url = root.getAttribute('data-lp-url') || '';
    var DISMISS_KEY = 'lp_dismissed_v1';

    var player = root.querySelector('.lp-player');
    var video = root.querySelector('[data-lp-video]');
    var cover = root.querySelector('[data-lp-cover]');
    var closeBtn = root.querySelector('[data-lp-close]');
    var hideTimer = null;
    var loaded = false;

    function inWindow() {
      if (isNaN(start) || isNaN(end)) return false;
      var now = Math.floor(Date.now() / 1000);
      return now >= start && now < end;
    }
    function dismissed() {
      try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
    }
    function shouldShow() {
      if (preview) return true;
      if (!enabled || !url) return false;
      if (dismissed()) return false;
      return inWindow();
    }

    function marketingAllowed() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp) return false;
        if (typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
        if (typeof cp.userCanBeTracked === 'function') return cp.userCanBeTracked();
      } catch (e) {}
      return false;
    }

    function loadStream() {
      if (loaded || !url || !video) return;
      // A local looping clip is the media — don't load the FB iframe at all.
      if (root.getAttribute('data-lp-clip') === '1') return;
      // The FB embed (plugins/video.php) only resolves a VIDEO/LIVE permalink, not an
      // event/page link. For non-video links keep the teaser cover (click-through still works).
      var isVideoUrl = /\/videos?\/|\/watch|fb\.watch|\/live\b|\/reel\//i.test(url);
      if (!isVideoUrl) return;
      // GDPR: only embed the Facebook player (which sets marketing cookies) with consent.
      if (!preview && !marketingAllowed()) return; // keep the teaser cover; the click-through still works
      var ifr = document.createElement('iframe');
      ifr.className = 'lp-iframe';
      ifr.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share');
      ifr.setAttribute('allowfullscreen', 'true');
      ifr.setAttribute('title', 'Facebook live');
      ifr.src = 'https://www.facebook.com/plugins/video.php?href=' +
        encodeURIComponent(url) +
        '&show_text=false&autoplay=true&mute=1&width=320&height=180';
      video.insertBefore(ifr, video.firstChild);
      if (cover) cover.style.display = 'none';
      loaded = true;
    }

    function show() {
      if (!root.hidden) return;
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      root.hidden = false;
      window.requestAnimationFrame(function () { root.classList.add('is-visible'); });
      loadStream();
      var clipEl = root.querySelector('.lp-clip');
      if (clipEl) { var pr = clipEl.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    function hide() {
      if (root.hidden) return;
      root.classList.remove('is-visible');
      hideTimer = setTimeout(function () { root.hidden = true; }, 300);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
        hide();
      });
    }

    // Retry the stream load once consent resolves (banner accepted after page load).
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
      document.addEventListener('visitorConsentCollected', function () { if (!root.hidden) loadStream(); });
    } catch (e) {}

    if (shouldShow()) show();

    // Re-check every 15s: auto-open at the start time, auto-close at the end time.
    setInterval(function () {
      if (preview) return;
      var visible = !root.hidden;
      if (shouldShow() && !visible) show();
      else if (!inWindow() && visible) hide();
    }, 15000);
  })();

  } catch(e) { console.error(e); }
})();
})();
